import { useEffect, useState } from "react";
import { Activity } from "lucide-react";
import { Progress } from "@/components/ui/progress";
import { api, errMsg, fmtDate } from "@/lib/api";
import { PageHeader, EmptyState } from "@/components/Common";

export default function Usage() {
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.get("/usage").then((r) => setD(r.data)).catch((e) => setErr(errMsg(e))); }, []);
  if (err) return <div className="text-red-300">{err}</div>;
  if (!d) return <div className="text-slate-400">Lade…</div>;
  const pct = d.limit ? Math.min(100, (d.today / d.limit) * 100) : 0;

  return (
    <div data-testid="usage-page">
      <PageHeader title="Nutzung & Protokoll" subtitle="Zeit, Modell, Provider, Status und Dauer jeder Anfrage. Prompt-Inhalte werden nicht gespeichert. Kosten: unknown (keine verifizierten Preise)." />
      <section className="glass mb-6 p-6" data-testid="usage-limit-card">
        <div className="flex items-end justify-between">
          <div><div className="label">Heute</div><div className="mt-1 text-3xl font-bold text-white font-display" data-testid="usage-today">{d.today}{d.limit != null && <span className="text-lg text-slate-500"> / {d.limit}</span>}</div></div>
          <div className="text-sm text-slate-400">{d.limit == null ? "Admin – kein Tageslimit" : `${Math.max(0, d.limit - d.today)} Anfragen übrig`}</div>
        </div>
        {d.limit != null && <Progress value={pct} className="mt-4 h-2" />}
      </section>
      <section className="glass overflow-x-auto">
        {d.logs.length === 0 ? <div className="p-6"><EmptyState testid="usage-empty" icon={Activity} title="Noch keine Anfragen" text="Starte im Playground oder über die API." /></div> : (
          <table className="w-full text-sm" data-testid="usage-table">
            <thead className="text-left text-xs uppercase tracking-wider text-slate-500"><tr>{["Zeit", "Quelle", "Provider", "Modell", "Status", "Dauer", "Tokens", "Request-ID"].map((h) => <th key={h} className="px-4 py-3 font-semibold">{h}</th>)}</tr></thead>
            <tbody>
              {d.logs.map((l) => (
                <tr key={l.id} className="border-t border-white/5">
                  <td className="px-4 py-3 text-slate-300 whitespace-nowrap">{fmtDate(l.ts)}</td>
                  <td className="px-4 py-3 text-slate-400">{l.source}</td>
                  <td className="px-4 py-3 text-slate-200">{l.provider}</td>
                  <td className="px-4 py-3 text-slate-400 max-w-[220px] truncate">{l.model || "–"}</td>
                  <td className="px-4 py-3">{l.status === "success" ? <span className="text-emerald-300">OK{l.fallback_used ? " (Fallback)" : ""}</span> : <span className="text-red-300">{l.error_code}</span>}</td>
                  <td className="px-4 py-3 text-slate-400">{l.duration_ms} ms</td>
                  <td className="px-4 py-3 text-slate-400">{l.tokens_in != null ? `${l.tokens_in} / ${l.tokens_out}` : "–"}</td>
                  <td className="px-4 py-3 font-mono text-xs text-slate-500">{l.id}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </section>
    </div>
  );
}
